// Method to convert any string to First letter capital
// e.g. FRANCE => France | france => France

export default function capitalizeFirstLetter(input) {
  let capitalizedString = input.toLowerCase();
  capitalizedString =
    capitalizedString.charAt(0).toUpperCase() + capitalizedString.slice(1);
  return capitalizedString;
}
